// Mock data for ລາຍການລໍຖ້າໂອນເງິນ COD (tab 1 = waiting, tab 2 = completed).
// Flip USE_MOCK in ./api.js to swap to the real backend with zero component changes.

import i18n from '@/i18n';

// Translation keys of the COD type labels; resolved at call time so the active locale applies.
const COD_TYPES = {
  combined: 'codTransferWaiting.cod_type_combined',
  completed: 'common.Success',
};

const SEED_NAMES = [
  { name: 'BUBER SHOP',      tel: '96460888' },
  { name: 'HAL CENTER',      tel: '76476162' },
  { name: 'BUI SHOP',        tel: '78081691' },
  { name: 'ຮ້ານ DT-FASHION', tel: '96829525' },
  { name: 'ຮ້ານ D&T SHOP',    tel: '95906891' },
  { name: 'ຮ້ານ D&T GIOBAL',  tel: '96773662' },
  { name: 'ຮ້ານ KP SHOP',     tel: '20991234' },
  { name: 'ຮ້ານ Lao Mart',    tel: '20887766' },
  { name: 'ຮ້ານ N1 Store',    tel: '20554433' },
  { name: 'ຮ້ານ Phonethip',   tel: '20336688' },
];

const TYPE_KEYS = ['combined', 'completed'];
const WITHDRAW_PERCENTS = [10, 20, 30];
const FEE_PERCENTS = [1, 2, 3];
const BILL_AMOUNTS = [12000000, 8500000, 15400000, 6200000, 9800000, 22000000];

// Demo slip images that work without any external CDN — embedded SVG data URI.
function buildSlipDataUri(label) {
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 160 120'>
    <rect width='160' height='120' rx='8' fill='%23ffffff' stroke='%23d9dde3'/>
    <rect x='12' y='14' width='80' height='10' rx='2' fill='%23195BFF'/>
    <rect x='12' y='32' width='136' height='6' rx='2' fill='%23eef0f4'/>
    <rect x='12' y='44' width='110' height='6' rx='2' fill='%23eef0f4'/>
    <rect x='12' y='56' width='90' height='6' rx='2' fill='%23eef0f4'/>
    <text x='80' y='86' text-anchor='middle' font-family='Arial' font-size='14' font-weight='700' fill='%23195BFF'>${label}</text>
    <text x='80' y='104' text-anchor='middle' font-family='Arial' font-size='9' fill='%238b8f99'>BANK TRANSFER SLIP</text>
  </svg>`;
  return `data:image/svg+xml;utf8,${svg.replace(/\n\s*/g, '')}`;
}

function generateWaiting(total = 127) {
  const list = [];
  for (let i = 0; i < total; i++) {
    const seed = SEED_NAMES[i % SEED_NAMES.length];
    list.push({
      id: 1000 + i,
      name: seed.name,
      customer_tel: seed.tel,
      bill_count: BILL_AMOUNTS[i % BILL_AMOUNTS.length],
      cod_type_key: TYPE_KEYS[i % TYPE_KEYS.length],
      withdraw_percent: WITHDRAW_PERCENTS[i % WITHDRAW_PERCENTS.length],
      fee_percent: FEE_PERCENTS[i % FEE_PERCENTS.length],
      status: 'waiting',
    });
  }
  return list;
}

function generateCompleted(total = 127) {
  const list = [];
  for (let i = 0; i < total; i++) {
    const seed = SEED_NAMES[i % SEED_NAMES.length];
    const day = (((i % 28) + 1)).toString().padStart(2, '0');
    const month = ((i % 12) + 1).toString().padStart(2, '0');
    list.push({
      id: 2000 + i,
      name: seed.name,
      customer_tel: seed.tel,
      bill_count: BILL_AMOUNTS[i % BILL_AMOUNTS.length],
      cod_type_key: TYPE_KEYS[i % TYPE_KEYS.length],
      withdraw_percent: WITHDRAW_PERCENTS[i % WITHDRAW_PERCENTS.length],
      fee_percent: FEE_PERCENTS[i % FEE_PERCENTS.length],
      status: 'completed',
      slip_image_url: buildSlipDataUri(`Slip #${1000 + i}`),
      transfer_date: `2026-${month}-${day}`,
    });
  }
  return list;
}

export const COD_WAITING_LIST = generateWaiting(127);
export const COD_COMPLETED_LIST = generateCompleted(127);

export function getCodTypeLabel(key) {
  return COD_TYPES[key] ? i18n.t(COD_TYPES[key]) : key;
}
